import { CommonNode, documentToReactComponents } from "@contentful/rich-text-react-renderer";
import * as RichTextTypes from "@contentful/rich-text-types";
import { BLOCKS, Document, INLINES, MARKS } from "@contentful/rich-text-types";
import Hyperlink from "components/Hyperlink";

import clsx from "clsx";
import typography from "components/typography";
import type { ReactElement, ReactNode } from "react";

export interface RichText {
  json: Document;
}

const richTextParser = (content: RichText, size?: "Small" | "Medium") => {
  if (!content) {
    return null;
  }
  size = size ?? "Medium";
  const { json } = content;

  const options = {
    renderText: (text: string) => {
      text = text.replace("[cross]", "").replace("[check]", "");
      return <span dangerouslySetInnerHTML={{ __html: text }}></span>;
    },
    renderMark: {
      [MARKS.BOLD]: (text: ReactNode) => <span className="font-black">{text}</span>,
      [MARKS.ITALIC]: (text: ReactNode) => <em>{text}</em>,
      [MARKS.UNDERLINE]: (text: ReactNode) => <span className="underline">{text}</span>,
      [MARKS.CODE]: (text: ReactNode) => (
        <code className="inline-block break-all rounded bg-primary-dark-100 px-2xs font-mono text-[90%] leading-snug">
          {text}
        </code>
      ),
      [MARKS.SUBSCRIPT]: (text: ReactNode) => {
        return <span className="text-xs font-medium text-primary-light-500">{text}</span>;
      },
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node: CommonNode, children: ReactNode) => children,
      [INLINES.HYPERLINK]: (node: CommonNode, children: ReactNode) => {
        const { data } = node;
        return (
          <Hyperlink href={data.uri} className="group relative font-medium">
            <span className="pointer-events-none absolute left-0 top-full h-[1px] w-full origin-[100%_50%] scale-x-0 bg-current transition-transform duration-300 group-hover:origin-[0%_50%] group-hover:scale-x-100"></span>
            {children}
          </Hyperlink>
        );
      },
    },
  };

  return documentToReactComponents(json, options) as ReactElement[];
};

export default richTextParser;
